import { render, staticRenderFns } from "./SettingHeroSupportLevelHistory.vue?vue&type=template&id=888af6ec&scoped=true&"
import script from "./SettingHeroSupportLevelHistory.vue?vue&type=script&lang=js&"
export * from "./SettingHeroSupportLevelHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "888af6ec",
  null
  
)

export default component.exports